<template>
<div class="checkbox inline left"  @click="not(value)">
  <div class="pointer check-button" :class="{active : value, TA:isTestAchat}"></div>
  <div class="pointer check-label grow" :class="{TA:isTestAchat}" v-html="label"></div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    label: {
      type: String,
      required: false
    },
    value: {
      type: [Boolean, Number]
    }
  },
  computed: {
    ...mapGetters("common", ["isTestAchat"])
  },  
  methods: {
    not(value) {
      if(value) value = 0;
      else value = 1;

      this.$emit("input", value);
    },
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  color: #4d545a;
  font-size: 0.9rem;
  padding: 5px 20px;
  cursor: pointer;

  .check-button {
    width: 16px;
    height: 16px;
    border: 2px solid $grey;
    border-radius: 4px;

    &.active {
      border: 2px solid $yellow;
      background: $yellow;
      position: relative;

      &::before {
        content: '';
        background:url("~@/assets/icons/icon-check.svg") no-repeat center/14px 14px $yellow;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }

      & + .check-label {
        font-weight: 500;
      }
    }

    &.TA {
      &.active {
        border: 2px solid $black;
        background: $black;

        &::before {
          background:url("~@/assets/icons/icon-check-white.svg") no-repeat center/14px 14px $black;
        }
      }
    }
  }
}

.check-label {
  text-align: left;
  display: block;
  margin: 0;
  margin-left: 10px;
  max-width: calc(100% - 40px);

  &.TA /deep/ a {
    color: $pink!important;
    text-decoration: underline $pink!important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/simulation/OptionField.vue